import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

function FaqItem({ q, a, id }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#27272A]" data-testid={`faq-item-${id}`}>
      <button
        data-testid={`faq-toggle-${id}`}
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-6 py-5 text-left group"
        aria-expanded={open}
      >
        <span className="font-display font-bold uppercase text-lg sm:text-xl text-zinc-200 group-hover:text-white transition-colors">
          {q}
        </span>
        <ChevronDown
          className={`w-5 h-5 text-[#FF5500] shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <p className="pb-5 text-zinc-400 leading-relaxed max-w-3xl">{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function Faq({ items, prefix = "faq" }) {
  return (
    <div className="border-t border-[#27272A]">
      {items.map((item, i) => (
        <FaqItem key={i} q={item.q} a={item.a} id={`${prefix}-${i}`} />
      ))}
    </div>
  );
}
